module.exports = __webpack_public_path__ + "img/logo.3dfe49ad.png";